import { useEffect, useSyncExternalStore } from 'react';

/* The last crumb of the top bar: the resource or tab a page shows, set by the page itself. */

let current: string | null = null;
const listeners = new Set<() => void>();

function set(label: string | null) {
  current = label;
  listeners.forEach((l) => l());
}

function subscribe(l: () => void) {
  listeners.add(l);
  return () => listeners.delete(l);
}

/** Call from a page that shows one resource (or a tab): `useCrumb(vm?.name)`. Cleared when the page goes. */
export function useCrumb(label: string | null | undefined) {
  useEffect(() => {
    if (!label) return;
    set(label);
    return () => set(null);
  }, [label]);
}

export function useCurrentCrumb(): string | null {
  return useSyncExternalStore(subscribe, () => current);
}
